import $ from "jquery";
import * as formatter from "@rmlibrary/formatting";

export const lang = document.documentElement.lang;

function populateYears() {
    const yearToday = new Date().getFullYear();
    const optionEl = $("#mortgage-year");
    $(optionEl).html("");
    let options = "";

    for (let i = yearToday; i >= 1900; i--) {
        options += `<option value="${i}" ${i === yearToday ? "selected" : ""}>${i}</option>`;
    }

    $(optionEl).append(options);
}

function populateDays() {
    const year = Number($("#mortgage-year").val());
    const selectedMonth = Number($("#mortgage-month").val());
    const selectedDay = Number($("#mortgage-day").val());

    $("#mortgage-day option").removeClass("hidden");

    switch (selectedMonth) {
        case 1:
        case 3:
        case 5:
        case 7:
        case 8:
        case 10:
        case 12:
            break;
        case 2:
            if (isLeapYear(year)) {
                $("#mortgage-day option").eq(28).addClass("hidden");
                $("#mortgage-day option").eq(29).addClass("hidden");
                $("#mortgage-day option").eq(30).addClass("hidden");
                if (selectedDay > 28) {
                    $("#mortgage-day option").eq(27).prop("selected", "true");
                }
            } else {
                $("#mortgage-day option").eq(29).addClass("hidden");
                $("#mortgage-day option").eq(30).addClass("hidden");
                if (selectedDay > 29) {
                    $("#mortgage-day option").eq(28).prop("selected", "true");
                }
            }
            break;
        default:
            $("#mortgage-day option").eq(30).addClass("hidden");
            if (selectedDay > 30) {
                $("#mortgage-day option").eq(29).prop("selected", "true");
            }
            break;
    }
}

function isLeapYear(year) {
    if (year % 400 === 0) {
        return true;
    }

    if (year % 100 === 0) {
        return false;
    }

    if (year % 4 === 0) {
        return true;
    }

    return false;
}

function numericOnlyInputs(inputPage, format = false) {
    // console.log(formatter);
    const numericInputs = $(inputPage).find("input[data-format='number']");
    numericInputs.on("input", ({ target }) => {
        const reg = lang === "en" ? /[^0-9.]/g : /[^0-9,\s]/g;
        if (reg.test(target.value)) {
            target.value = target.value.replace(reg, "");
        }
    });
    for (let i = 0; i < numericInputs.length; i++) {
        if (format) {
            numericInputs.eq(i).on("blur", ({ target }) => {
                $(target).val(
                    formatter.formatNumber($(target).val() || 0, {
                        lang: lang,
                        decPlaces: (formatter.parseNumber($(target).val()) || 0) % 1 === 0 ? 0 : 2,
                    }),
                );
            });

            if (lang === "en") {
                numericInputs.eq(i).on("focus", ({ target }) => {
                    if ($(target).val()) {
                        $(target).val(formatter.parseNumber($(target).val()));
                    }
                });
            }
        }
    }
}

function validateNumberField(inputElement, errorMessageOutOfRange, dependantInputs, previousValidity = false) {
    const value = formatter.parseNumber($(inputElement).val());
    const errorContainer = $(inputElement).parent().siblings(".warning");
    let validity = true;
    const minValue = $(inputElement).data("min");
    const maxValue = $(inputElement).data("max");

    if (value === undefined || value === "" || isNaN(value)) {
        // $(errorWhenEmpty).show();
        validity = false;
    } else if (value < minValue || value > maxValue) {
        $(errorContainer).show();
        $(errorContainer).find("p").text(errorMessageOutOfRange);
        validity = false;
    } else if (dependantInputs.length !== 0) {
        for (let i = 0; i < dependantInputs.length; i++) {
            if (dependantInputs[i]) {
                const { input, rule, message, isMonths, mapping } = dependantInputs[i];
                let dependantVal = 0;
                if (mapping) {
                    dependantVal = getMapping(formatter.parseNumber($(input).val()));
                } else {
                    dependantVal = formatter.parseNumber($(input).val()) * (isMonths ? 12 : 1);
                }
                if (!eval(`${value} ${rule} ${dependantVal}`)) {
                    validity = false;
                    $(errorContainer).show();
                    $(errorContainer).find("p").text(message);
                    break;
                }
            }
        }
    }

    if (validity) {
        $(errorContainer).hide();
        $(errorContainer).find("p").text("");
    }

    if (!validity && previousValidity) {
        $(inputElement).trigger("focus");
    }

    return validity;
}

function getMapping(rate) {
    switch (rate) {
        case 0:
        case 1:
            return 6;
        case 2:
        case 3:
            return 12;
        case 4:
            return 24;
        case 5:
        case 12:
            return 36;
        case 6:
            return 48;
        case 7:
        case 10:
        case 11:
            return 60;
        case 8:
            return 84;
        case 9:
            return 120;
    }
}
export { populateYears, populateDays, numericOnlyInputs, validateNumberField, getMapping };
